<template>
  <v-card flat>
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-combobox
          v-model="departure"
          :items="cities"
          label="Departure"
          :filter="comboFilter"
          outlined
          clearable
          dense
          prepend-icon=""
          :rules="departureRules"
        ></v-combobox>
        <v-combobox
          v-model="destination"
          :items="cities"
          label="Destination"
          :filter="comboFilter"
          clearable
          outlined
          dense
          :rules="destinationRules"
        ></v-combobox>
        <v-combobox
          v-model="fleet"
          :items="fleets"
          label="Fleet"
          :filter="comboFilter"
          clearable
          outlined
          dense
          item-text="name"
          item-value="id"
          :rules="fleetRules"
        ></v-combobox>
        <v-combobox
          v-model="vessel"
          :items="filteredVessels"
          label="Vessel"
          :filter="comboFilter"
          :disabled="disable"
          clearable
          outlined
          dense
          item-text="name"
          item-value="id"
          ref="vessel"
          :rules="vesselRules"
        ></v-combobox>
        <v-text-field
          v-model.number="persons"
          :disabled="disable"
          type="number"
          min="1"
          step="1"
          outlined
          dense
          ref="persons"
          :rules="personsRules"
          label="Persons on Board"
          @keydown="keyDown"
        ></v-text-field>
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Date"
              prepend-icon="mdi-calendar-today"
              readonly
              v-bind="attrs"
              :rules="startRules"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker show-current v-model="date" @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapState } from "vuex";
  export default {
    name: 'Voyage',

    data: () => ({
      menu2: false,
      valid: true,
      disable: true,
      departureRules: [
        v => !!v || "Departure is required"
      ],
      destinationRules: [
        v => !!v || "Destination is required"
      ],
      fleetRules: [
        v => !!v || "Fleet is required"
      ],
      vesselRules: [
        v => !!v || "Vessel is required"
      ],
      personsRules: [
        v => !!v || "Persons on Board is required",
        v => v > 0 || "Persons on Board must be one or more"
      ],
      startRules: [
        v => new Date(v) > (function(){this.setDate(this.getDate()-1); return this})
                  .call(new Date) || "Start must be today or in future"
      ]
    }),
    computed: {
      ...mapState({
        cities: state => state.static.cities,
        fleets: state => state.static.fleets,
        filteredVessels: state => {
          return state.static.vessels.filter(
            v => {
              let f = state.input.fleet;
              if (!f) {
                return false;
              }
              let ret = false;
              f.vessels.forEach(fv => {
                if (!ret) {
                  ret = v.id == fv ? true : false
                }
              })
              return ret;
            }
          )
        }
      }),
      departure: {
        get() {
          return this.$store.state.input.departure;
        },
        set(value) {
          this.$store.commit("setDeparture", value);
        }
      },
      destination: {
        get() {
          return this.$store.state.input.destination;
        },
        set(value) {
          this.$store.commit("setDestination", value);
        }
      },
      fleet: {
        get() {
          return this.$store.state.input.fleet;
        },
        set(value) {
          if (value) {
            this.disable = false;
          }
          else {
            this.disable = true;
            this.vessel = undefined;
          }
          this.$refs.vessel.reset();
          this.$refs.persons.reset();
          this.$store.commit("setFleet", value);
        }
      },
      vessel: {
        get() {
          return this.$store.state.input.vessel;
        },
        set(value) {
          this.$store.commit("setVessel", value);
          if (!value) {
            return;
          }
          this.$store.state.input.length = undefined;
          this.$store.state.input.width = undefined;
          this.$store.state.input.height = undefined;
          this.$store.state.input.draught = undefined;
          this.$store.state.input.speed = undefined;
          this.$store.state.input.tonnage = undefined;
          let me = this;
          let p = this.$store.state.static.vesselTypes.find(vt => {
            if (!me.$store.state.input.vessel) {
              return false;
            }
            return vt.id == me.$store.state.input.vessel.vesselType;
          })
          if (p) {
            this.$store.commit("setVesselType", p);
            this.$store.commit("setPersonsOnBoard", p.personsOnBoard)
          }
        }
      },
      persons: {
        get() {
          return this.$store.state.input.personsOnBoard;
        },
        set(value) {
          this.$store.commit("setPersonsOnBoard", value);
        }
      },
      date: {
        get() {
          let date = (new Date(this.$store.state.input.date)).toISOString().substr(0,10);
          return date;
        },
        set(value) {
          this.$store.commit("setDate", value);
        }
      }
    },
    mounted() {
      if (this.$store.state.input.fleet) {
        this.disable = false;
      }
    },
    methods: {
      save: function() {
        localStorage.setItem("ces-state", JSON.stringify(this.$store.state.input));
      },
      validate: function() {
        return this.$refs.form.validate();
      },
      resetValidation: function() {
        this.$refs.form.resetValidation();
      },
      comboFilter: function(item, filterText, itemText) {
        return itemText.toLowerCase().startsWith(filterText.toLowerCase());
      },
      keyDown: function(e) {
        console.log(e);
        if ((/^[a-z,A-Z]$/i.test(event.key))) {
          e.preventDefault(true);
        }
      }
    }
  }
</script>
